﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eDynamicSource, eOutputFieldType } from "@models/enums";
import { IWordImageField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.WordImageField, eOutputFieldType.wordImage)
export class WordImageField extends OutputField implements IWordImageField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }
    public deleted: boolean;
    public filePath: string;
    public source: string = eDynamicSource.template;
    public sourceId: string;
    public fixContentControlSize: boolean;
}
